const getDaysInMonth = (month: string, year: string): number => {
  return new Date(+year, +month, 0).getDate();
};
export default getDaysInMonth;
